
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...route]]",
      function () {
        return require("private-next-pages/[[...route]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...route]]"])
      });
    }
  